import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Features() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  const features = [
    {
      icon: 'ri-megaphone-line',
      title: 'Content That Converts',
      description: 'From viral reels to compelling carousels, we create thumb-stopping content that drives engagement and turns scrollers into customers.',
      link: 'See Examples',
      primary: true
    },
    {
      icon: 'ri-user-star-line',
      title: 'Influencer Partnerships',
      description: 'Connect with the right voices in your industry. We manage end-to-end influencer campaigns that amplify your brand authentically.',
      link: 'Learn More',
      primary: false
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Data-Driven Strategy',
      description: 'Every decision backed by analytics. We track, measure, and optimize to ensure your marketing budget delivers maximum ROI.',
      link: 'Our Approach',
      primary: false
    }
  ];

  return (
    <section
      ref={ref}
      className={`py-28 bg-gray-50 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Marketing That Actually Works
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-gray-600 text-lg leading-relaxed">
              We don't just post and pray. Our strategic approach combines creative excellence with performance marketing to deliver measurable results for your brand.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-[#00989e] transition-all hover:shadow-xl flex flex-col ${
                feature.primary ? 'lg:col-span-1' : ''
              } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: isVisible ? `${index * 100}ms` : '0ms', transitionDuration: '500ms' }}
            >
              <div className="w-16 h-16 bg-[#00989e] rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow">
                {feature.description}
              </p>
              <a
                href="#"
                className="inline-flex items-center gap-2 text-[#00989e] font-semibold hover:gap-3 transition-all cursor-pointer mt-auto"
              >
                {feature.link}
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
